import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const EditorialCreamOutro: React.FC<OutroProps> = ({
  keywords,
  frame,
  fps,
}) => {
  const pulseScale = 1.0 + Math.sin((frame / fps) * Math.PI * 1.5) * 0.04;

  return (
          <div
            style={{
              width: "100%",
              background: "#fdfcf7",
              border: "1px solid rgba(100, 80, 60, 0.15)",
              borderRadius: "2px",
              boxShadow: "0 15px 35px rgba(100, 80, 60, 0.05)",
              padding: "50px 40px",
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              position: "relative",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            {/* Corners décor */}
            <div
              style={{
                position: "absolute",
                top: "15px",
                left: "15px",
                width: "15px",
                height: "15px",
                borderTop: "1px solid rgba(100, 80, 60, 0.4)",
                borderLeft: "1px solid rgba(100, 80, 60, 0.4)",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                width: "15px",
                height: "15px",
                borderTop: "1px solid rgba(100, 80, 60, 0.4)",
                borderRight: "1px solid rgba(100, 80, 60, 0.4)",
              }}
            />

            <div
              style={{
                fontFamily: "'Playfair Display', serif",
                fontStyle: "italic",
                fontWeight: 600,
                fontSize: "14px",
                color: "#6b532f",
                letterSpacing: "1px",
              }}
            >
              — Stay Briefed —
            </div>

            <h2
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: "44px",
                fontWeight: 700,
                lineHeight: 1.3,
                color: "#281e14",
                marginBottom: "30px",
              }}
            >
              Never Miss A Tech Shock
            </h2>

            {/* Pulsing CTA Action Button */}
            <div
              style={{
                transform: `scale(${pulseScale})`,
                transition: "transform 0.1s ease",
                cursor: "pointer",
                width: "80%",
                maxWidth: "350px",
                background: "#6b532f",
                borderRadius: "2px",
                padding: "20px 0",
                boxShadow: "0 10px 30px rgba(107, 83, 47, 0.15)",
                marginBottom: "30px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontFamily: "'Playfair Display', serif",
                  fontWeight: 700,
                  fontSize: "24px",
                  color: "#fdfcf7",
                  textTransform: "uppercase",
                  letterSpacing: "2px",
                }}
              >
                🔔 Follow the Column
              </span>
            </div>

            <div
              style={{
                fontFamily: "'Playfair Display', serif",
                fontStyle: "italic",
                fontSize: "24px",
                fontWeight: 600,
                color: "rgba(40, 30, 20, 0.7)",
              }}
            >
              @TheDigitalBullet
            </div>
          </div>
        )
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
